import toCssSizeMixin from '../mixins/to-css-size-mixin';
import getFileUrlMixin from '../mixins/get-file-url-mixin';

export default ({Vue}) => {

  Vue.mixin(toCssSizeMixin);
  Vue.mixin(getFileUrlMixin);
};
